export const FULL_FORMS = {
  AP_PE: 'AP Practice Exam',
  PE_2020_1_TAG: '2020 Practice Exam 1',
  PE_2020_2_TAG: '2020 Practice Exam 2',
  PE_2020_3_TAG: '2020 Practice Exam 3',
};

const { AP_PE } = FULL_FORMS;

export const RESTRICT_CHILD_TAGS = [AP_PE];
